import { createSlice } from '@reduxjs/toolkit';
import type { AsyncStatus } from '@/shared/types/asyncState';
import type { ServicoStatus } from '../../types/plataforma';
import { fetchPlataformaStatus } from './actions';

interface PlataformaStatusState {
  servicos: ServicoStatus[];
  uptimeGlobal: number;
  servicosOnline: number;
  servicosDegradados: number;
  servicosOffline: number;
  checkTime: string | null;
  loading: boolean;
  error: string | null;
  status: AsyncStatus;
}

const initialState: PlataformaStatusState = {
  servicos: [],
  uptimeGlobal: 0,
  servicosOnline: 0,
  servicosDegradados: 0,
  servicosOffline: 0,
  checkTime: null,
  loading: false,
  error: null,
  status: 'idle',
};

const plataformaStatusSlice = createSlice({
  name: 'plataformaStatus',
  initialState,
  reducers: {
    resetPlataformaStatus: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlataformaStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(fetchPlataformaStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.servicos = action.payload.servicos;
        state.uptimeGlobal = action.payload.uptimeGlobal;
        state.servicosOnline = action.payload.servicosOnline;
        state.servicosDegradados = action.payload.servicosDegradados;
        state.servicosOffline = action.payload.servicosOffline;
        state.checkTime = action.payload.checkTime;
        state.status = 'success';
      })
      .addCase(fetchPlataformaStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
      });
  },
});

export const { resetPlataformaStatus } = plataformaStatusSlice.actions;
export const plataformaStatusReducer = plataformaStatusSlice.reducer;
